import {
  Box,
  Typography,
  Card,
  CardContent,
  Link as MuiLink,
} from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import FlagCircleIcon from "@mui/icons-material/FlagCircle";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { GoogleLoginButton } from "@/components/GoogleLoginButton";

export function Login() {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "80vh",
      }}
    >
      <MuiLink
        component={Link}
        to="/"
        sx={{
          display: "flex",
          alignItems: "center",
          gap: 0.5,
          mb: 4,
          textDecoration: "none",
        }}
      >
        <ArrowBackIcon fontSize="small" />
        {t("login.backToHome")}
      </MuiLink>
      <FlagCircleIcon color="primary" sx={{ fontSize: 56, mb: 1 }} />
      <Typography
        variant="h5"
        gutterBottom
        sx={{
          fontWeight: 700,
        }}
      >
        {t("login.title")}
      </Typography>
      <Typography
        variant="body2"
        sx={{
          color: "text.secondary",
          mb: 4,
        }}
      >
        {t("login.subtitle")}
      </Typography>
      <Card sx={{ maxWidth: 400, width: "100%" }}>
        <CardContent sx={{ p: 4, textAlign: "center" }}>
          <Typography
            variant="h5"
            gutterBottom
            sx={{
              fontWeight: 700,
            }}
          >
            {t("login.welcomeBack")}
          </Typography>
          <Typography
            variant="body2"
            sx={{
              color: "text.secondary",
              mb: 3,
            }}
          >
            {t("login.signInDesc")}
          </Typography>
          <GoogleLoginButton />
        </CardContent>
      </Card>
    </Box>
  );
}
